// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"c4984fe8","408":"f6d0be3e","499":"7dbc6d6b"}[chunkId] + ".chunk.css";
};